import { useState } from 'react'
import { Breadcrumbs } from '@/components/misc/Breadcrumbs'
import { Avatar } from '@/components/ui/Avatar'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Textarea } from '@/components/ui/Textarea'
import { Select, SelectItem } from '@/components/ui/Select'
import { Edit, UploadCloud, Trash2 } from 'lucide-react'

export default function AdminRolePage() {
  const [firstName, setFirstName] = useState('Wade')
  const [lastName, setLastName] = useState('Warren')
  const [password, setPassword] = useState('********')
  const [phone, setPhone] = useState('(406) 555-0120')
  const [email, setEmail] = useState('wade.warren@example.com')
  const [dob, setDob] = useState('1999-01-12')
  const [location, setLocation] = useState('2972 Westheimer Rd. Santa Ana, Illinois 85486')
  const [creditCard, setCreditCard] = useState('843-4359-4444')
  const [bio, setBio] = useState('Enter a biography about you')
  const [currentPwd, setCurrentPwd] = useState('')
  const [newPwd, setNewPwd] = useState('')
  const [rePwd, setRePwd] = useState('')
  const [imagePreview, setImagePreview] = useState(null)

  const handleImage = (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setImagePreview(URL.createObjectURL(file))
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">Admin role</h1>
          <Breadcrumbs />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left column */}
        <div className="space-y-4">
          <div className="bg-card border rounded-xl p-4">
            <div className="flex flex-col items-center text-center">
              <Avatar size="xl" alt={firstName + ' ' + lastName} fallback={firstName + ' ' + lastName} />
              <h3 className="mt-3 font-semibold">{firstName} {lastName}</h3>
              <div className="text-sm text-muted-foreground">{email}</div>
              <div className="mt-3 text-sm text-muted-foreground">Linked with Social media</div>
              <div className="mt-3 flex items-center gap-2">
                <button className="px-3 py-1 bg-muted rounded text-sm">Social media</button>
              </div>
            </div>
          </div>

          <div className="bg-card border rounded-xl p-4">
            <h4 className="font-medium">Change Password</h4>
            <div className="mt-3">
              <label className="text-sm">Current Password</label>
              <Input value={currentPwd} onChange={(e) => setCurrentPwd(e.target.value)} placeholder="Enter password" />
            </div>
            <div className="mt-3">
              <label className="text-sm">New Password</label>
              <Input value={newPwd} onChange={(e) => setNewPwd(e.target.value)} placeholder="Enter password" />
            </div>
            <div className="mt-3">
              <label className="text-sm">Re-enter Password</label>
              <Input value={rePwd} onChange={(e) => setRePwd(e.target.value)} placeholder="Enter password" />
            </div>
            <div className="mt-4">
              <Button variant="primary" size="md" className="w-full">Save Change</Button>
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-card border rounded-xl p-6">
            <div className="flex items-start justify-between">
              <h3 className="text-lg font-medium">Profile Update</h3>
              <div className="flex items-center gap-2">
                <label className="inline-flex items-center px-3 py-2 bg-muted rounded cursor-pointer">
                  <UploadCloud className="h-4 w-4 mr-2" /> Upload New
                  <input type="file" accept="image/*" className="hidden" onChange={handleImage} />
                </label>
                <Button variant="ghost" size="sm"><Trash2 className="h-4 w-4" /></Button>
                <Button variant="ghost" size="sm"><Edit className="h-4 w-4" /></Button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div>
                <label className="text-sm">First Name</label>
                <Input value={firstName} onChange={(e) => setFirstName(e.target.value)} />
              </div>
              <div>
                <label className="text-sm">Last Name</label>
                <Input value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>

              <div>
                <label className="text-sm">Password</label>
                <Input value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
              <div>
                <label className="text-sm">Phone Number</label>
                <Input value={phone} onChange={(e) => setPhone(e.target.value)} />
              </div>

              <div>
                <label className="text-sm">E-mail</label>
                <Input value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              <div>
                <label className="text-sm">Date of Birth</label>
                <Input value={dob} onChange={(e) => setDob(e.target.value)} />
              </div>

              <div className="md:col-span-2">
                <label className="text-sm">Location</label>
                <Input value={location} onChange={(e) => setLocation(e.target.value)} />
              </div>

              <div>
                <label className="text-sm">Credit Card</label>
                <Select value={creditCard} onValueChange={(v) => setCreditCard(v)}>
                  <SelectItem value={creditCard}>{creditCard}</SelectItem>
                </Select>
              </div>

              <div className="md:col-span-2">
                <label className="text-sm">Biography</label>
                <Textarea value={bio} onChange={(e) => setBio(e.target.value)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}